import axios from "axios";
import { useEffect, useRef, useState } from "react";
import {toast} from "react-toastify";

export default function ShopInfo(props) {
  const [selectedImage, setSelectedImage] = useState("");
  const [urlPictureToSend, setUrlPictureToSend] = useState("");

  const handleChangeForPictureUpload = (e) => {
    setSelectedImage(URL.createObjectURL(e.target.files[0]));
    const formData = new FormData();
    formData.append("files[]", e.target.files[0]);
    axios({
      method: "post",
      url: `${localStorage.getItem("apiUrl")}/logo/`, data: formData,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      response= response.data;
      if(response.status){
        setUrlPictureToSend(response.logo);
      }else {
        setUrlPictureToSend("ErrorAddressFromServer");
      }
    });
  };

  const formRef = useRef(null);
  useEffect(() => {
    axios({
      method: "get",
      url: `${localStorage.getItem("apiUrl")}/settings/`,
      params: { settingName: "institute" },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      let form = formRef.current;
      for (let key in response.data) {
        if(key!=="Logo_Co"){
          form[key].value = response.data[key];
        }
        if(key==="Logo_Co"){
          setSelectedImage(response.data[key]);
          console.log("check if its true!!:  "+response.data[key])
        }
        
      }
    });
  }, []);

  function submitStore(e) {
    e.preventDefault();
    let form = e.target;
    var formData = new FormData(form);
    formData.append("Logo_Co", urlPictureToSend);
    axios({
      method: "post",
      url: `${localStorage.getItem("apiUrl")}/settings/`,
      params: { settingName: "institute" },
      data: formData,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response)=>{
      toast.success("اطلاعات ثبت شد.")
    });
  }
  return (
    <form ref={formRef} onSubmit={submitStore}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>نام موسسه یا فروشگاه</label>
            <input type="text" name="Name_Co" className="form-control" />
          </div>
          <div className="form-group">
            <label>استان</label>
            <input type="text" name="Province_Co" required className="form-control" />
          </div>
          <div className="form-group">
            <label>شهر</label>
            <input type="text" name="City_Co" required className="form-control" />
          </div>
          <div className="form-group">
            <label>آدرس</label>
            <input type="text" name="Add_Co" className="form-control" />
          </div>
          <div className="form-group">
            <label>تلفن</label>
            <input type="text" name="Tell_Co" className="form-control" />
          </div>
          <div className="form-group">
            <label>موبایل</label>
            <input type="text" name="Mobil_Co" className="form-control" />
          </div>
          <div className="form-group">
            <label>شماره مجوز یا کد اقتصادی</label>
            <input type="text" name="code_Shop" className="form-control" />
          </div>
          <div className="form-group">
            <label>سایت</label>
            <input type="text" name="Site_Shop" className="form-control" />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>تلگرام</label>
            <input type="text" name="Telgram_Shop" className="form-control" />
          </div>
          <div className="form-group">
            <label>اینستاگرام</label>
            <input type="text" name="Insta_Shop" className="form-control" />
          </div>
          <div className="form-group">
            <label>سایر</label>
            <input type="text" name="Other_Shop" className="form-control" />
          </div>
          <div className="form-group ">
            <label>لوگو فروشگاه</label>
            {/* <input type="text" class="form-control position-absolute" placeholder="فایل لوگو را انتخاب کنید"> */}
          </div>
          <div className="logo-container position-relative">
            <label
              className="btn btn-info"
              style={{ width: "100%" }}
              for="select-logo"
            >
              <span> آپلود عکس جدید </span>
            </label>
            <input
              type="file"
              className="form-control"
              id="select-logo"
              onChange={handleChangeForPictureUpload}
            />

            <img alt="logo" id="logoImg" src={selectedImage}  />
          </div>
        </div>
      </div>
      <div className="text-center">
        <input type="submit" value="ثبت" className="btnCustom btnSubmit" />
      </div>
    </form>
  );
}
